import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.css']
})
export class SwitchComponent {
    @Input() model: boolean = false; // Legge il valore dell'ngModel
    @Output() modelChange: EventEmitter<boolean> = new EventEmitter<boolean>(); // Comunica i valori aggiornati

    toggleSwitch() {
        this.model = !this.model; // Inverte il valore
        this.modelChange.emit(this.model); // Emette il nuovo valore
    }
}